import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  events: [],
  currentEvent: null,
  loading: false,
  error: null,
  view: 'month', // month, week, day
  currentDate: new Date().toISOString().split('T')[0],
  filters: {
    type: 'all', // lecture, homework, exam, meeting
    group: 'all',
    professor: 'all'
  }
}

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    setEvents: (state, action) => {
      state.events = action.payload
    },
    setCurrentEvent: (state, action) => {
      state.currentEvent = action.payload
    },
    addEvent: (state, action) => {
      state.events.push(action.payload)
    },
    updateEvent: (state, action) => {
      const index = state.events.findIndex(event => event.id === action.payload.id)
      if (index !== -1) {
        state.events[index] = action.payload
      }
    },
    removeEvent: (state, action) => {
      state.events = state.events.filter(event => event.id !== action.payload)
    },
    setView: (state, action) => {
      state.view = action.payload
    },
    setCurrentDate: (state, action) => {
      state.currentDate = action.payload
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
    },
    clearError: (state) => {
      state.error = null
    }
  }
})

export const {
  setLoading,
  setError,
  setEvents,
  setCurrentEvent,
  addEvent,
  updateEvent,
  removeEvent,
  setView,
  setCurrentDate,
  setFilters,
  clearError
} = calendarSlice.actions

export default calendarSlice.reducer